import { Head, useForm } from '@inertiajs/react'
import { KeyRound, Save } from 'lucide-react'

import { AppShell } from '@/layouts/AppShell'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { FieldError } from '@/components/feedback/FieldError'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'

type PasswordResetEditFormProps = {
  title: string
  token: string
  patchPath: string
}

export function PasswordResetEditForm({ title, token, patchPath }: PasswordResetEditFormProps) {
  const { data, setData, patch, processing, errors, transform, reset } = useForm({
    password: '',
    password_confirmation: '',
  })

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((current) => ({ password_reset: current }))
    patch(patchPath.replace(':token', encodeURIComponent(token)), {
      onFinish: () => reset('password', 'password_confirmation'),
    })
  }

  return (
    <AppShell>
      <Head title={title} />
      <Card padding="lg" className="mx-auto w-full max-w-md space-y-8">
        <header className="space-y-2 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500/20 text-brand-100">
            <KeyRound className="h-5 w-5" />
          </div>
          <h1 className="text-2xl font-semibold text-white">{title}</h1>
          <p className="text-sm text-white/60">新しいパスワードを入力してください。</p>
        </header>

        <form onSubmit={submit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="password">新しいパスワード</Label>
            <Input
              id="password"
              type="password"
              value={data.password}
              onChange={(event) => setData('password', event.target.value)}
              autoComplete="new-password"
              required
            />
            <FieldError message={errors.password} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="passwordConfirmation">新しいパスワード（確認）</Label>
            <Input
              id="passwordConfirmation"
              type="password"
              value={data.password_confirmation}
              onChange={(event) => setData('password_confirmation', event.target.value)}
              autoComplete="new-password"
              required
            />
            <FieldError message={errors.password_confirmation} />
          </div>

          <Button type="submit" className="w-full" loading={processing}>
            <Save className="h-4 w-4" />
            パスワードを更新
          </Button>
        </form>
      </Card>
    </AppShell>
  )
}
